import {CircularProgress, Grid, Paper, TextField} from "@material-ui/core";
import React from "react";
import {Alert} from "@material-ui/lab";
import useStyles from "../../styles/styles";


const PerformanceSummaryTable = ({data, loading, error}) => {
    const classes = useStyles();

    if (loading) {
        return (
            <>
                <Paper className={classes.paper}>
                    <CircularProgress color="inherit"/>
                </Paper>
            </>
        );
    }

    if (error || !data) {
        return (
            <>
                <Paper className={classes.paper}>
                    <Alert severity="error">Well, this in embarrassing&hellip; something went wrong.</Alert>
                </Paper>
            </>
        );
    }

    return (
        <>
            <Paper className={classes.paper}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Time to First Campaign Request"
                                   value={data.timeToFirstCampaignHttpRequest + " seconds" || ''}
                                   readOnly fullWidth/>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField label="Total Synchronous Posting Time"
                                   value={data.totalSynchronousPostingTime + " seconds" || ''}
                                   readOnly fullWidth/>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default PerformanceSummaryTable